import { apiClient } from "../lib/api";

export const productionReadinessApi = {
  get: () => apiClient.get("/system/readiness"),
};
